export const SET_PERSONAL_LIST = 'SET_PERSONAL_LIST'
export const SET_ENTERPRISE_LIST = 'SET_ENTERPRISE_LIST'
export const SET_PROJECT_LIST = 'SET_PROJECT_LIST'
export const SET_FILTER_DATA = 'SET_FILTER_DATA'
export const SET_WORKSPACE = 'SET_WORKSPACE'

